import "./gen2-recruit/header"
import "./gen2-recruit/barba"
import "./gen2-recruit/watchScroll"

window.addEventListener("load", () => {
    let nowWidth = window.innerWidth > 1024

    window.addEventListener("resize", () => {
        if (nowWidth != window.innerWidth > 1024) {
            window.location.reload();
        }
    })
})